import { Routes } from "@angular/router";
import { WtfMainComponent } from "./components/main/main.component";
import { LoggedUserGuard } from "./utils/guards/core/logged-user.guard";
import { UnLoggedUserGuard } from "./utils/guards/core/unlogged-user.guard";
import { SignInComponent } from "./components/security/authentication/sign-in/sign-in.component";
import { RecoveryRequestComponent } from "./components/security/authentication/recovery-request/recovery-request.component";
import { ResetPasswordComponent } from "./components/security/authentication/reset-password/reset-password.component";
import { VerifyPinComponent } from "./components/security/authentication/verify-pin/verify-pin.component";

export const ROUTES: Routes = [
    {
        path: "",
        component: WtfMainComponent,

        children: [
            {
                path: "",
                redirectTo: "webhome",
                pathMatch: "full",
            },

            {
                path: "",
                canActivate: [LoggedUserGuard],
                /*  children: [
                    {
                        path: '',
                        component: WtfSampleComponent
                    }
                ]*/
                loadChildren: () =>
                    import(
                        "./components/mediaManager/mediaManager.module"
                    ).then((m) => m.MediaManagerModule),
            },
        ],
    },
    {
        path: "login",
        canActivate: [UnLoggedUserGuard],
        loadChildren: () =>
            import("./components/security/security.module").then(
                (m) => m.SecurityModule
            ),
    },
    {
        path: "verify",
        component: VerifyPinComponent,
    },
    {
        path: "signin",
        canActivate: [UnLoggedUserGuard],
        component: SignInComponent,
    },
    {
        path: "recovery-request",
        canActivate: [UnLoggedUserGuard],
        component: RecoveryRequestComponent,
    },
    {
        path: "recovery",
        canActivate: [UnLoggedUserGuard],
        component: ResetPasswordComponent,
    },
];
